// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle:after{content:normal}.social-grid{display:flex;flex:0 1 100%;flex-flow:row wrap;justify-content:space-evenly;max-width:250px;padding:0}.social-grid__item{align-items:center;color:#000!important;color:#fff;display:flex;font-size:20px;justify-content:center}.social-grid__item:hover{cursor:pointer;filter:alpha(opacity=70);opacity:.7;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
